function roundToTwo(num) {
    return +(Math.round(num + "e+2")  + "e-2");
}
function isFloat(n, forceReplaceComma){
    if(forceReplaceComma){
        n = String(n).replace(/,/g, '.')
        n = parseFloat(n)
    }
    return Number(n) === n && n % 1 !== 0;
}

function isInt(n, forceReplaceComma){
    if( ! (/^\d+$/.test(n))) return false;
    if(forceReplaceComma){
        n = String(n).replace(/,/g, '.')
        n = parseInt(n)
    }
    return Number(n) === n && n % 1 === 0;
}
function countDecimals (value) {
    //if( ! (/^\d+$/.test(value))) return false;
    if(Math.floor(value) === parseFloat(value)) return 0;
    return value.toString().split(".")[1] && value.toString().split(".")[1].length || 0;
}
export { roundToTwo, isFloat, isInt, countDecimals }